import React from 'react';
import { ConnectedTopDestinations } from './TopDestinationsDesktop';
import { Config, LocationUtils } from '../../utils';

export function TopDestinationsSourceDesktop({ id, activeProduct }) {
    return {
        render: ({
            onClickItem,
            displayedWord = '',
            trackAutocompleteSourceState,
            trackAutocompleteSourceSelection,
        } = {}) => {
            const show = !LocationUtils.isKeywordLongEnoughAccordingWithLanguage(
                displayedWord,
                Config.get('autocompleteOptions'),
                activeProduct,
            );
            return (
                <ConnectedTopDestinations
                    key="top-destinations"
                    id={id}
                    onClickItem={onClickItem}
                    show={show}
                    trackAutocompleteSourceState={trackAutocompleteSourceState}
                    trackAutocompleteSourceSelection={trackAutocompleteSourceSelection}
                />
            );
        },
    };
}
